import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'
import { Props } from './LocationLink'
import { useMemo } from 'react'

export function useData(props: Props) {
  const { externalLinkId, externalLinkType } = props
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  const locationUrl = useMemo(() => {
    let url: string = ''

    if (externalLinkType != null) {
      switch (externalProduct) {
        case externalProductPestPacName:
          switch (externalLinkType.toLowerCase()) {
            case 'billto':
              url = `${clientUrl}/billto/edit.asp?Mode=Edit&BillToID=${externalLinkId}`
              break
            case 'location':
              url = `${clientUrl}/location/detail.asp?LocationID=${externalLinkId}`
              break
          }
          break
      }
    }

    return url
  }, [clientUrl, externalLinkId, externalProduct, externalLinkType])

  return { locationUrl }
}
